import React, { useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Row, Col, Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { Spinner } from '../../components'
import useAiCreditData from './hooks/useAiCreditData'
// import useDateFilter from './hooks/useDateFilter'
import OrganizationUsage from './components/OrganizationUsage'
import UsageByService from './components/UsageByService'
// import TopCreditUsers from './components/TopCreditUsers'
import EmptyState from './components/EmptyState'
import ErrorState from './components/ErrorState'
import './AiCreditUsageReport.scss'
import NewHeader from '../../components/NewHeader'
import ChevronRightIcon from '../../assets/icons/chevron-right-icon.svg'
import ReportsIcon from '../../assets/icons/reports-icon.svg'
import moment from 'moment'
const AiCreditUsageReport = ({ history }) => {
  const { t } = useTranslation()

  // Date filter, search, and user data management
  /* const {
    userData,
    userLoading,
    userError,
    pagination,
    searchTerm,
    tableFilter,
    setTableFilter,
    selectedType,
    setSelectedType,
    onSearch,
    onPageChange,
    refetchUsers
  } = useDateFilter('5') */

  // Default values for commented out data request
  const userData = []
  const userLoading = false
  const userError = null
  const pagination = { current: 1, pageSize: 10, total: 0 }
  const searchTerm = ''
  const tableFilter = 'All Time'
  const setTableFilter = () => { }
  const selectedType = ''
  const setSelectedType = () => { }
  const onSearch = () => { }
  const onPageChange = () => { }
  const refetchUsers = () => { }

  // Organization-level credit data
  const { data: creditData, loading: creditLoading, error: creditError, refetch: refetchCredits } = useAiCreditData()

  const loading = creditLoading || userLoading
  const error = creditError || userError

  // Calculate active types from usageByFeature
  const activeTypes = useMemo(() => {
    if (!creditData?.usageByFeature) return []
    return Object.entries(creditData.usageByFeature)
      .filter(([_, value]) => value > 0)
      .map(([key]) => key)
  }, [creditData])

  // Auto-select first active type
  /* React.useEffect(() => {
    if (activeTypes.length > 0 && !selectedType) {
      setSelectedType(activeTypes[0])
    }
  }, [activeTypes, selectedType, setSelectedType]) */

  const data = useMemo(() => {
    if (!creditData) return null
    return {
      ...creditData,
      topUsers: userData
    }
  }, [creditData, userData])

  const refetch = useCallback(() => {
    refetchCredits()
    // refetchUsers()
  }, [refetchCredits, refetchUsers])

  // Memoized handlers
  const handlePurchaseClick = useMemo(
    () => () => {
      // TODO: Implement purchase credits functionality
      console.log('Purchase credits clicked')
    },
    []
  )

  /* const handleExportClick = useCallback(() => {
    if (!userData || userData.length === 0) return

    // Prepare CSV header
    const header = ['Rank', 'Entity', 'Credits Used', 'Details']

    // Prepare CSV data rows
    const rows = userData.map((row, index) => {
      const rank = (pagination?.current - 1) * pagination?.pageSize + index + 1
      return [
        rank,
        row.name,
        row.totalCreditsUsed,
        row.level
      ]
    })

    // Combine header and rows
    const csvContent = [header, ...rows]
      .map(e => e.map(v => `"${String(v).replace(/"/g, '""')}"`).join(','))
      .join('\n')

    // Download CSV
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    const fileName = `ai_credit_usage_${selectedType || 'report'}_${moment().format('YYYY-MM-DD')}.csv`

    a.href = url
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }, [userData, pagination, selectedType]) */

  const handleExportClick = () => { }

  /* const handleHistoryClick = useMemo(
    () => () => {
      // TODO: Implement history view functionality
      console.log('History clicked')
    },
    []
  ) */

  const handleHistoryClick = () => { }

  const handleRetry = useMemo(
    () => () => {
      refetch()
    },
    [refetch]
  )

  // Determine view state
  const viewState = useMemo(() => {
    // Only show full page loading on initial load of organization data
    if (creditLoading && !creditData) return 'loading'

    // Only show error if we have no data at all
    if (error && !data) return 'error'

    // Only show empty if finished loading and no data
    if (!data && !loading) return 'empty'

    return 'success'
  }, [creditLoading, userLoading, creditData, error, data, loading])

  // Render based on state
  const renderContent = () => {
    switch (viewState) {
      case 'loading':
        return (
          <div className="ai-credit-loading-container">
            <Spinner height="50vh" />
          </div>
        )

      case 'error':
        return (
          <ErrorState error={error} onRetry={handleRetry} />
        )

      case 'empty':
        return (
          <EmptyState
            description={t('reports:no_credit_usage_data') || 'No credit usage data available'}
            onRefresh={handleRetry}
          />
        )

      case 'success':
        return (
          <>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <div>
                  <h3 className="org-title">Organization Usage</h3>
                </div>
              </Col>
              <Col xs={24} lg={12}>
                <OrganizationUsage
                  data={data}
                  loading={creditLoading}
                  onPurchaseClick={handlePurchaseClick}
                />
              </Col>
              <Col xs={24} lg={12}>
                <UsageByService data={data} loading={creditLoading} />
              </Col>
            </Row>

            {/* <Row gutter={[24, 24]}>
              <Col xs={24}>
                <TopCreditUsers
                  data={data}
                  loading={userLoading}
                  onExportClick={handleExportClick}
                  onHistoryClick={handleHistoryClick}
                  onSearch={onSearch}
                  searchTerm={searchTerm}
                  pagination={pagination}
                  onPageChange={onPageChange}
                  tableFilter={tableFilter}
                  onTableFilterChange={setTableFilter}
                  activeTypes={activeTypes}
                  selectedType={selectedType}
                  onTypeChange={setSelectedType}
                />
              </Col>
            </Row> */}
          </>
        )

      default:
        return null
    }
  }

  const goBack = () => {
    history.push('/reports')
  }
  return (
    <div className="ai-credit-usage-report">
      <div className="ai-credit-nav-header">
        <div className="ai-credit-usage-report-breadcrumbs">
          <button className="breadcrumb-home" onClick={() => goBack()}>
            <img src={ReportsIcon} alt="Home" width="20" height="20" />
            Reports
          </button>
          <span className="breadcrumb-sep">
            <img src={ChevronRightIcon} alt=">" width="24" height="24" />
          </span>
          <span className="breadcrumb-settings">
            Ai Credits Usage
          </span>
        </div>
        <div className="ai-credit-usage-report-newheader">
          <NewHeader />
        </div>
      </div>
      <div className="report-header">
        <div className="header-content">
          <div className="title-section">
            <h1 className="main-title">AI Credits Usage</h1>
            <p className="subtitle">
              Real-time visibility into AI credits usage at the organization level
            </p>
          </div>
          {/* <Button
            type="primary"
            onClick={handlePurchaseClick}
            disabled={true}
          >
            <PlusOutlined />Purchase more credits
          </Button> */}
        </div>
      </div>

      <div className="report-body">
        {renderContent()}
      </div>
    </div>
  )
}

AiCreditUsageReport.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
}

export default withRouter(AiCreditUsageReport)
